module.exports = __webpack_public_path__ + "img/188.3b9121dd.jpg";